import { useParams } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { H2, P } from "../../../../AbstractElements";
import { ProductDetail, ProductTittle } from "../../../../Constant";
import { useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { ProductColor } from "./ProductColor";
import { ProductDetailButton } from "./ProductDetailButton";
import { ProductRating } from "./ProductRating";
import { ProductSocial } from "./ProductSocial";
import { ProductTable } from "./ProductTable";

const ProductDetails = () => {
  const id = useParams();
  const { symbol } = useAppSelector((state) => state.product);

  return (
    <Col xl="5" className="box-col-6 order-xxl-0 order-1">
      <Card>
        <CardBody>
          <div className="product-page-details">
            <H2>{ProductTittle}</H2>
          </div>
          <div className="product-price">
            {symbol}26.00<del>{symbol}350.00 </del>
          </div>
          <ProductColor />
          <P>{ProductDetail}</P>
          <hr />
          <ProductTable />
          <ProductSocial />
          <ProductRating />
          <ProductDetailButton id={id.id} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default ProductDetails;
